import { Breadcrumb } from 'antd';
import {
  HomeOutlined,
  PictureOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const PatientPhotosPageBreadCrumb = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  return (
    <Breadcrumb
      items={[
        {
          onClick: () => {
            navigate('/');
          },
          title: (
            <span style={{ cursor: 'pointer' }}>
              <HomeOutlined style={{ marginRight: 4 }} />
              <span>{t('breadcrumb.admin')}</span>
            </span>
          ),
        },
        {
          onClick: () => {
            navigate(`/patients/${id}`);
          },
          title: (
            <span style={{ cursor: 'pointer' }}>
              <UserOutlined style={{ marginRight: 4 }} />
              <span>{t('breadcrumb.patient')}</span>
            </span>
          ),
        },
        {
          title: (
            <>
              <PictureOutlined />
              <span>{t('breadcrumb.photos')}</span>
            </>
          ),
        },
      ]}
    />
  );
};
